<template>
  <div class="i-landing-photo">
    <img
      :src="Hero"
      alt="Career coaching professional"
      :class="{ loaded: imageLoaded }"
      @load="onLoad"
    />
  </div>
</template>

<script setup>
import { ref } from "vue"

import Hero from "@/assets/images/first-step-hero.webp"

const imageLoaded = ref(false)
function onLoad() {
  imageLoaded.value = true
}
</script>

<style lang="scss" scoped>
.i-landing-photo {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 38vh;
  min-height: 200px;
  background: $white;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 20%;
    opacity: 0;
    transition: opacity 1.2s ease;
    /* stylelint-disable */
    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
    /* stylelint-enable */
    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);

    &.loaded {
      opacity: 1;
    }
  }

  @include respond-to($breakpoint-md) {
    height: 100%;
    min-height: unset;

    img {
      object-position: 25% center;
      /* stylelint-disable */
      -webkit-mask-image: linear-gradient(to right, black 35%, transparent 70%);
      /* stylelint-enable */
      mask-image: linear-gradient(to right, black 35%, transparent 70%);
    }
  }
}
</style>
